import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ButtonComponent } from './button.component';
import { DynamicTranslationModule } from '../../dynamic-translation/dynamic-translation.module';

@NgModule({
  imports: [CommonModule, DynamicTranslationModule],
  declarations: [ButtonComponent],
  exports: [ButtonComponent]
})
export class ButtonModule {}
